export default __webpack_public_path__ + "static/media/close.e98d18bc.svg";